import { css } from "styled-components";
import rgba from "polished/lib/color/rgba";
import { riotProductSkin } from "../riot-product";
export const arcaneSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  background-color: ${rgba(paletteTokens.underlay, 0.7)};
`;
//# sourceMappingURL=index.js.map